import React, { createContext, useContext, useState } from "react";

interface Neo4jVisualizerContextType {
  isOpen: boolean;
  focusNodeId: string | null;
  openVisualizer: (nodeId?: string) => void;
  closeVisualizer: () => void;
}

const Neo4jVisualizerContext = createContext<Neo4jVisualizerContextType | undefined>(undefined);

interface Neo4jVisualizerProviderProps {
  children: React.ReactNode;
}

export const Neo4jVisualizerProvider: React.FC<Neo4jVisualizerProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [focusNodeId, setFocusNodeId] = useState<string | null>(null);

  const openVisualizer = (nodeId?: string) => {
    setFocusNodeId(nodeId || null);
    setIsOpen(true);
  };

  const closeVisualizer = () => {
    setIsOpen(false);
    setFocusNodeId(null);
  };

  return (
    <Neo4jVisualizerContext.Provider
      value={{
        isOpen,
        focusNodeId,
        openVisualizer,
        closeVisualizer,
      }}
    >
      {children}
    </Neo4jVisualizerContext.Provider>
  );
};

export const useNeo4jVisualizer = (): Neo4jVisualizerContextType => {
  const context = useContext(Neo4jVisualizerContext);
  if (!context) {
    throw new Error("useNeo4jVisualizer must be used within a Neo4jVisualizerProvider");
  }
  return context;
};